export default __webpack_public_path__ + "917289b.png";